import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { inspectDeviceStorage } from "../../utils/deviceProgress";

export default function StorageHealth({ controls = false }: { controls?: boolean }) {
    const { t } = useTranslation("common");
    const [lost, setLost] = useState(false);
    const [state, setState] = useState("checking");
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        let active = true;
        const check = () => {
            void inspectDeviceStorage().then(value => { if (active) setLost(value); }).catch(() => { if (active) setState("error"); });
        };
        check();
        window.addEventListener("focus", check);
        if (controls) {
            if (!navigator.storage?.persisted || !navigator.storage?.persist) setState("unsupported");
            else void navigator.storage.persisted().then(value => { if (active) setState(value ? "protected" : "available"); }).catch(() => { if (active) setState("error"); });
        }
        return () => { active = false; window.removeEventListener("focus", check); };
    }, [controls]);
    async function protect() {
        setBusy(true);
        try { setState(await navigator.storage.persist() ? "protected" : "denied"); }
        catch { setState("error"); }
        finally { setBusy(false); }
    }
    if (!controls && !lost) return null;
    return <section aria-label={t("storageHealth.title")}>
        {lost && <p role="alert">{t("storageHealth.lost")}</p>}
        {controls && <><h2>{t("storageHealth.title")}</h2><p>{t("storageHealth.limits")}</p>
            <p role="status">{t(`storageHealth.${state}`)}</p>
            {["available", "denied", "error"].includes(state) && typeof navigator.storage?.persist === "function" && <button disabled={busy} onClick={protect}>{t("storageHealth.request")}</button>}
        </>}
    </section>;
}
